import { render, staticRenderFns } from "./IconSvgAsae.vue?vue&type=template&id=f713882c&scoped=true&"
import script from "./IconSvgAsae.vue?vue&type=script&lang=js&"
export * from "./IconSvgAsae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f713882c",
  null
  
)

export default component.exports